import { onBeforeUpdate as _onBeforeUpdate } from "gyron";
import { h as _h } from "gyron";
import { Guidance } from '@/components/guidance';
import { ROUTE_MENUS, CORE_ROUTE_MENUS, BLOG_ROUTE_MENUS, ROUTE_MENUS_EN, CORE_ROUTE_MENUS_EN, BLOG_ROUTE_MENUS_EN } from '@/pages';
import { useRouter, Link } from '@gyron/router';
import { resolve } from '@gyron/shared';
import { useMemo, FC } from 'gyron';
import { ArrowLeftBoldIcon, ArrowRightBoldIcon } from './icons';
import { $t } from '@/langs';
const RoutesMap = {
  docs: ROUTE_MENUS,
  core: CORE_ROUTE_MENUS,
  blog: BLOG_ROUTE_MENUS,
  'en-US/docs': ROUTE_MENUS_EN,
  'en-US/core': CORE_ROUTE_MENUS_EN,
  'en-US/blog': BLOG_ROUTE_MENUS_EN
};
export const MdxContainer = FC(({
  children,
  menu,
  lang,
  parentPath
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props = props;
    children = _props.children;
    menu = _props.menu;
    lang = _props.lang;
    parentPath = _props.parentPath;
  })
  const router = useRouter();
  const state = useMemo(() => {
    const routes = RoutesMap[parentPath];
    const index = routes.findIndex(item => resolve(parentPath, item.path) === router.path);
    if (index >= 0) {
      const prev = routes[index - 1];
      const next = routes[index + 1];
      return {
        prev: prev,
        next: next
      };
    }
    return {
      prev: null,
      next: null
    };
  });
  const prevName = useMemo(() => {
    if (state.value.prev && state.value.prev?.meta?.group) {
      return `${state.value.prev.name}(${state.value.prev.meta.group})`;
    }
    return state.value.prev.name;
  });
  const nextName = useMemo(() => {
    if (state.value.next && state.value.next?.meta?.group) {
      return `${state.value.next.name}(${state.value.next.meta.group})`;
    }
    return state.value.next.name;
  });
  return ({
    children,
    menu,
    lang,
    parentPath
  }) => _h("article", {
    "class": "relative z-20",
    "itemScope": true,
    "itemType": "http://schema.org/Article"
  }, [_h("span", {
    "hidden": true,
    "itemScope": true,
    "itemProp": "author",
    "itemType": "http://schema.org/Person"
  }, [_h("meta", {
    "itemProp": "name",
    "content": "Link"
  }, []), _h("meta", {
    "itemProp": "url",
    "content": "https://github.com/Linkontoask"
  }, [])]), _h("meta", {
    "itemProp": "image",
    "content": "/assets/image/logo-sm.png"
  }, []), _h(Guidance, {
    "navigation": menu.anchor
  }, []), _h("div", {
    "class": "prose prose-slate mt-8 dark:prose-invert max-w-none"
  }, children), _h("footer", {
    "class": "text-sm leading-6 mt-12"
  }, [_h("div", {
    "class": "mb-10 text-slate-700 font-semibold flex items-center dark:text-slate-200"
  }, [state.value.prev && _h(Link, {
    "to": state.value.prev.path,
    "className": "group flex items-center cursor-pointer hover:text-slate-900 dark:hover:text-white no-underline"
  }, [_h(ArrowLeftBoldIcon, {}, []), prevName.value]), state.value.next && _h(Link, {
    "to": state.value.next.path,
    "className": "group ml-auto flex items-center cursor-pointer hover:text-slate-900 dark:hover:text-white no-underline"
  }, [nextName.value, _h(ArrowRightBoldIcon, {}, [])])]), _h("div", {
    "class": "pt-10 pb-28 border-t border-slate-200 sm:flex justify-between text-slate-500 dark:border-slate-200/5"
  }, [_h("div", {
    "class": "mb-6 sm:mb-0 sm:flex"
  }, _h("p", {}, [_h("span", {}, ["Copyright \xA9 ", new Date().getFullYear(), " Link"]), _h("span", {
    "class": "border-l border-slate-400 ml-4 pl-4"
  }, ["\n                  Produced with\n                  ", _h("a", {
    "href": "https://github.com/gyronorg/docs",
    "class": "underline"
  }, "\n                    @gyron/docs\n                  ")])])), _h("a", {
    "href": `https://github.com/gyronorg/docs/tree/master/src/app/source/${lang}/${menu.meta.page}.mdx`,
    "target": "_blank",
    "class": "hover:text-slate-900 dark:hover:text-slate-400"
  }, $t('JSXText_133_13_135_12'))])])]);
});